/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_New_ChatInputs */

const en_admin_ai_chat_new_chat = /** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Chat`)
};

const de_admin_ai_chat_new_chat = /** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer Chat`)
};

const es_admin_ai_chat_new_chat = /** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo chat`)
};

const fr_admin_ai_chat_new_chat = /** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau chat`)
};

const nl_admin_ai_chat_new_chat = /** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe chat`)
};

/** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */
const it_admin_ai_chat_new_chat = en_admin_ai_chat_new_chat;

/** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_new_chat = en_admin_ai_chat_new_chat;

/** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */
const pl_admin_ai_chat_new_chat = en_admin_ai_chat_new_chat;

/** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */
const hu_admin_ai_chat_new_chat = en_admin_ai_chat_new_chat;

/** @type {(inputs: Admin_Ai_Chat_New_ChatInputs) => LocalizedString} */
const ro_admin_ai_chat_new_chat = en_admin_ai_chat_new_chat;

/**
* | output |
* | --- |
* | "New Chat" |
*
* @param {Admin_Ai_Chat_New_ChatInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_new_chat = /** @type {((inputs?: Admin_Ai_Chat_New_ChatInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_New_ChatInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_new_chat(inputs)
	if (locale === "de") return de_admin_ai_chat_new_chat(inputs)
	if (locale === "es") return es_admin_ai_chat_new_chat(inputs)
	if (locale === "fr") return fr_admin_ai_chat_new_chat(inputs)
	if (locale === "nl") return nl_admin_ai_chat_new_chat(inputs)
	if (locale === "it") return it_admin_ai_chat_new_chat(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_new_chat(inputs)
	if (locale === "pl") return pl_admin_ai_chat_new_chat(inputs)
	if (locale === "hu") return hu_admin_ai_chat_new_chat(inputs)
	return ro_admin_ai_chat_new_chat(inputs)
});
export { admin_ai_chat_new_chat as "admin.ai_chat.new_chat" }